export default {
    ORBIT: 'orbit',
    FREE_RANGE: 'freerange'
};